import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { Grid } from '@mui/material';
import { formatPostalCode } from 'utils/formatters';
import { IJazzStoreAddress } from 'v3/services/interfaces/response';
import { BodySmallBold, BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { theme } from 'v3/styles/global-styles';
import { IconHeader } from '../IconHeader';
import { ContainerStores, Content, DivBreakWord, Header } from '../styles';

export const StoreAddress: React.FC<IJazzStoreAddress> = ({
  city,
  state,
  street,
  number,
  neighborhood,
  postalCode,
  complement,
}) => {
  return (
    <ContainerStores>
      <Header>
        <IconHeader Icon={RoomOutlinedIcon} />
        <SubtitleLarge>Endereço da loja</SubtitleLarge>
      </Header>
      <Content>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Cidade e estado</BodySmallRegular>
              <BodySmallBold>
                {city} - {state}
              </BodySmallBold>
            </DivBreakWord>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>CEP</BodySmallRegular>
              <BodySmallBold>{postalCode ? formatPostalCode(postalCode) : '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Bairro</BodySmallRegular>
              <BodySmallBold>{neighborhood ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Rua</BodySmallRegular>
              <BodySmallBold>{street ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Número</BodySmallRegular>
              <BodySmallBold>{number ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <DivBreakWord>
              <BodySmallRegular color={theme.palette.secondary.light}>Complemento</BodySmallRegular>
              <BodySmallBold>{complement ?? '-'}</BodySmallBold>
            </DivBreakWord>
          </Grid>
        </Grid>
      </Content>
    </ContainerStores>
  );
};
